import { RoundArrowButton, RoundArrowButtonDirection } from "@tfo/common"
import { useHistory } from "react-router-dom"
import { useStore } from "../../hooks/useStore"

export const BackButton = () => {
    const history = useHistory()
    const { clientViewStore } = useStore()

    const showBackButton = () => {
        const locationsWithoutBackbutton = ['/read-report', '/faq', '/start']
        const currentLocation = history.location.pathname
        return !(locationsWithoutBackbutton.includes(currentLocation) ||
            currentLocation.includes('/new-report-order') ||
            currentLocation.includes('/new-report-done') ||
            // Include sub-companies route because we need to hide btn when customer is from ATS
            (currentLocation.includes('/sub-companies') && clientViewStore.externalHostedOrderFlow) 
            || (currentLocation.includes('/service-packages') && clientViewStore.company?.subsidiaries?.length < 1 && clientViewStore.externalHostedOrderFlow)   
            || clientViewStore.lockedMode)
    }

    const goBackTo = () => {
        const currentLocation = history.location.pathname
        if (currentLocation.includes('/service-packages')) {
            clientViewStore.company.subsidiaries?.length > 0 ? history.push('/sub-companies') : history.push('/start')
        }
        else if (currentLocation.includes('/archived-group-order')) {
            history.push('/archive')
        }
        else if (currentLocation.includes('/grouporder')) {
            history.push('/reports')
        }
        else {
            history.push('/start')
        }
    }

    return (
        showBackButton() &&
        <div className={'ClientContainer__ArrowWrapper'}>
            <RoundArrowButton
                direction={RoundArrowButtonDirection.LEFT}
                outlined
                className={'ClientContainer__Back'}
                onClick={() => goBackTo()}
            />
        </div>)
}